import { SetGetHistoryList } from './thunk/setGetHistoryList'

export const Thunks ={
    SetGetHistoryList
}